<template>
  <div>
   <div class="searchBox">
    <div class="searchLeft">
      <el-input size="medium" v-model="searchForm.name" placeholder="请输入分类名称"  @keyup.enter.native="getTableList"></el-input>
      <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
    </div>
    <div class="searchRight">
      <el-button size="medium" type="primary" icon="el-icon-plus" @click="addFunc">增加</el-button>
    </div>
   </div>
   <el-table
    border
    :data="tableData"
    height="73vh"
    style="width: 100%">
    <el-table-column
      prop="name"
      label="分类名称">
    </el-table-column>
    <el-table-column
      prop="orderGoods.order_goods_no"
      label="是否可删">
      <template slot-scope="scope">
        <el-switch
        @change="ChangeTypeIsDel(scope.row)"
        v-model="scope.row.isDel"
        active-color="#999"
        inactive-color="#67c23a">
        </el-switch>
        <span v-if="scope.row.isDel" class="switchTxt">不可删除</span>
        <span v-else class="switchActiveTxt">可删除</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="way"
      label="操作">
      <template slot-scope="scope">
        <el-button size="mini" type="primary" @click="editType(scope.row)"><i class="el-icon-edit" style="margin-right:3px;"></i>修改</el-button>
        <el-button size="mini" type="danger" @click="deleteType(scope.row)" v-if="!scope.row.isDel"><i class="el-icon-delete" style="margin-right:3px;"></i>删除</el-button>
      </template>
    </el-table-column>
  </el-table>
    <el-dialog
    title="添加分类"
    :visible.sync="dialogVisible"
    width="440px">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="分类名称" prop="name">
            <el-input placeholder="请输入分类名称" v-model="ruleForm.name" style="width:240px"></el-input>
        </el-form-item>
        <el-form-item label="是否可删除" prop="isDel">
            <el-radio-group v-model="ruleForm.isDel">
                <el-radio :label="0">是</el-radio>
                <el-radio :label="1">否</el-radio>
            </el-radio-group>
        </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:20,
        name:'',
      },
      tableData: [],
      dialogVisible:false,
      ruleForm:{
          name:'',
          isDel:'',
          id:''
      },
      rules:{
          name: [
            { required: true, message: '请输入分类名称', trigger: 'blur' },
            { min: 2, max: 8, message: '长度在 2 到 8 个字符', trigger: 'blur' }
          ],
          isDel:[
              { required: true, message: '请选择是否可删除', trigger: 'change' }
          ]
      }
      
    };
  },
  created() {
    this.getTableList()
  },
  methods: {
    submitForm(formName) {
        this.$refs[formName].validate(async (valid) => {
            if (valid) {
                let res = await this.$http.addArticleType({...this.ruleForm});
                if (res) {
                  this.$message.success('操作成功！');
                  this.dialogVisible=false;
                  this.getTableList()
                }
            } else {
            console.log('error submit!!');
            return false;
            }
        });
    },
    deleteType(row){
        this.$confirm(`确定要删除 ${row.name} 分类吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let res = await this.$http.delArticleType({id:row.id});
          if (res) {
            this.$message.success('操作成功！');
            this.getTableList()
          }
        }).catch(() => {
                
        });
    },
    editType(row){
        this.ruleForm.id=row.id;
        this.ruleForm.name=row.name;
        this.ruleForm.isDel=Number(row.isDel);
        this.dialogVisible=true
    },

    addFunc(){
        this.ruleForm.id='';
        this.ruleForm.name='';
        this.ruleForm.isDel='';
        this.$nextTick(() => {
          this.$refs['ruleForm'].resetFields()
        })
        this.dialogVisible=true;
    },
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.articleTypeList({...this.searchForm});
        if (res) {
        this.tableData=res.data.map(x=>{
            x.isDel=Boolean(x.isDel)
            return x
        })
        }
    },
    async ChangeTypeIsDel(row){
        console.log(row.isDel)
        let res = await this.$http.updateTypeIsDel({id:row.id,isDel:row.isDel?1:0});
        if (res) {
        this.$message.success('操作成功！');
        this.getTableList()
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>

<style scoped>


</style>
